import React from 'react';
/**
 * Tells whether the element behind the returned ref has scrollable content below its visible area.
 * Re-checks on scroll and whenever the element or its children resize, so fields that expand
 * (e.g. a text box revealed by a checkbox) are picked up.
 */
export const useIsContentHiddenBelow = () => {
    const ref = React.useRef(null);
    const [isContentHiddenBelow, setIsContentHiddenBelow] = React.useState(false);
    React.useEffect(() => {
        const element = ref.current;
        if (!element) {
            return undefined;
        }
        // 1px tolerance absorbs sub-pixel rounding when scrolled to the very bottom.
        const check = () => {
            setIsContentHiddenBelow(element.scrollHeight - element.clientHeight - element.scrollTop > 1);
        };
        check();
        element.addEventListener('scroll', check, { passive: true });
        const observer = new ResizeObserver(check);
        observer.observe(element);
        Array.from(element.children).forEach(child => observer.observe(child));
        return () => {
            element.removeEventListener('scroll', check);
            observer.disconnect();
        };
    }, []);
    return { ref, isContentHiddenBelow };
};
